module.exports = __webpack_public_path__ + "static/img/21.813534cd.gif";